const formatCartState = cartState => {
  const { currency, ...rest } = cartState;
  return {
    ...rest,
    currency: currency ? currency.toLowerCase() : null
  };
};

export default formatCartState;
